// extracted by mini-css-extract-plugin
export var scrollArea = "_nk-0";